import React from 'react';
import './loadingDots.css';

const LoadingDots =  () => {
	return(
		<div className='loading-dots'>
			<h1 className='dot one'>.</h1><h1 className='dot two'>.</h1><h1 className='dot three'>.</h1>
		</div>
	);
};

export default LoadingDots;
